/** Strates de parution selon le nombre de parties jouées. */
export const REGISTER_PARUTION_STRATA = [
  {
    id: "veryRecent",
    title: "Joués un très grand nombre de fois",
    subtitle: "20 fois et plus",
    minCountInclusive: 20,
  },
  {
    id: "recent",
    title: "Joués un grand nombre de fois",
    subtitle: "Plus de 10 fois et moins de 20 fois",
    minCountExclusive: 10,
    maxCountExclusive: 20,
  },
  {
    id: "lessRecent",
    title: "Relativement peu joués",
    subtitle: "Plus de 5 fois et jusqu'à 10 fois",
    minCountExclusive: 5,
    maxCountInclusive: 10,
  },
  {
    id: "awhile",
    title: "Peu joués",
    subtitle: "Au moins 2 fois et jusqu'à 5 fois",
    minCountInclusive: 2,
    maxCountInclusive: 5,
  },
  {
    id: "longAgo",
    title: "Très peu joués",
    subtitle: "Moins de 2 fois",
    maxCountExclusive: 2,
  },
];
